import {
  plainMurnAddressFromFormkit,
  plainMurnAddressToFormkit,
  murnAddressToFormkit,
  murnAddressFromFormkit,
} from "@modernary/mui/components/fk";

import { type FacilitySite, type FacilitySiteNew } from "@/views/facilitySite/facilitySite";
import { fillAddressLookupValues, fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  fromFormkit,
  toFormkit,
  skinnyResponseAdapter,
  responseAdapter,
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: FacilitySite }) {
  addAuthRequestFields(response.data);
  await fillAddressLookupValues(response.data);
  await fillPrefixedAddressLookupValues(response.data, ["mail"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: FacilitySite }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function addAuthRequestFields(entity: FacilitySite | FacilitySiteNew) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof FacilitySite)[];
  return entity;
}

function getInitialData() {
  const result = {} as FacilitySite; //TODO:TS
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: FacilitySite) {
  murnAddressToFormkit(data, "mail");
  plainMurnAddressToFormkit(data);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {
  //TODO:TS
  murnAddressFromFormkit(data as FacilitySite, "mail");
  plainMurnAddressFromFormkit(data as FacilitySite);
}
